export const N550_SEGMENTS = [
  {
    id: "N550-SEG-001",
    label: "Santiago de Compostela Norte",
    path: [
      { lat: 42.86334, lng: -8.5434 },
      { lat: 42.86151, lng: -8.54138 },
      { lat: 42.85974, lng: -8.54054 },
      { lat: 42.85941, lng: -8.54056 },
      { lat: 42.8583, lng: -8.54018 },
      { lat: 42.85617, lng: -8.53983 },
      { lat: 42.85341, lng: -8.53921 },
      { lat: 42.85275, lng: -8.53927 },
      { lat: 42.85001, lng: -8.54107 },
      { lat: 42.84727, lng: -8.54191 },
      { lat: 42.84491, lng: -8.54256 },
      { lat: 42.84397, lng: -8.54338 },
      { lat: 42.84284, lng: -8.54519 },
      { lat: 42.84086, lng: -8.54706 },
      { lat: 42.84151, lng: -8.54899 },
      { lat: 42.84455, lng: -8.5514 },
      { lat: 42.84546, lng: -8.55392 },
      { lat: 42.84477, lng: -8.55545 },
      { lat: 42.8435, lng: -8.55427 },
      { lat: 42.8411, lng: -8.55431 },
      { lat: 42.83931, lng: -8.54956 },
      { lat: 42.83756, lng: -8.54512 },
      { lat: 42.83707, lng: -8.54445 },
      { lat: 42.8362, lng: -8.54442 },
      { lat: 42.8345, lng: -8.54599 },
      { lat: 42.83369, lng: -8.54597 },
      { lat: 42.83064, lng: -8.54665 },
      { lat: 42.82998, lng: -8.54653 },
      { lat: 42.82984, lng: -8.54634 },
      { lat: 42.82687, lng: -8.54599 },
      { lat: 42.82639, lng: -8.54579 },
      { lat: 42.82579, lng: -8.54411 },
      { lat: 42.82397, lng: -8.5436 },
      { lat: 42.82096, lng: -8.5449 },
      { lat: 42.82188, lng: -8.54964 },
      { lat: 42.82158, lng: -8.55146 },
      { lat: 42.82146, lng: -8.55426 },
      { lat: 42.82309, lng: -8.55641 },
      { lat: 42.82159, lng: -8.56045 },
      { lat: 42.81712, lng: -8.55968 }
    ],
  },
  {
    id: "N550-SEG-002",
    label: "Milladoiro",
    path: [
      { lat: 42.81712, lng: -8.55968 },
      { lat: 42.81371, lng: -8.56165 },
      { lat: 42.81281, lng: -8.56637 },
      { lat: 42.81067, lng: -8.56957 },
      { lat: 42.80885, lng: -8.57432 },
      { lat: 42.80745, lng: -8.57988 },
      { lat: 42.80642, lng: -8.58396 },
      { lat: 42.8048, lng: -8.58893 },
      { lat: 42.80245, lng: -8.59125 },
      { lat: 42.79997, lng: -8.59266 },
      { lat: 42.79716, lng: -8.59564 },
      { lat: 42.79556, lng: -8.59711 },
      { lat: 42.79409, lng: -8.59842 },
      { lat: 42.79377, lng: -8.60031 },
      { lat: 42.79354, lng: -8.60249 },
      { lat: 42.79388, lng: -8.60416 },
      { lat: 42.79404, lng: -8.60498 },
      { lat: 42.79395, lng: -8.60698 },
      { lat: 42.79404, lng: -8.60883 },
      { lat: 42.79342, lng: -8.61038 },
      { lat: 42.79201, lng: -8.61211 },
      { lat: 42.79038, lng: -8.61336 },
      { lat: 42.78876, lng: -8.61456 },
      { lat: 42.78568, lng: -8.61663 },
      { lat: 42.78279, lng: -8.6175 },
      { lat: 42.78082, lng: -8.61835 },
      { lat: 42.77751, lng: -8.61761 },
      { lat: 42.77541, lng: -8.61853 },
      { lat: 42.77288, lng: -8.61798 },
      { lat: 42.77161, lng: -8.61785 },
      { lat: 42.77012, lng: -8.61777 },
      { lat: 42.76956, lng: -8.61752 },
      { lat: 42.7687, lng: -8.61737 },
      { lat: 42.76703, lng: -8.61673 },
      { lat: 42.76561, lng: -8.61727 },
      { lat: 42.76497, lng: -8.61646 },
      { lat: 42.7641, lng: -8.6156 },
      { lat: 42.76304, lng: -8.61539 },
      { lat: 42.76197, lng: -8.61531 },
      { lat: 42.76096, lng: -8.61551 }
    ],
  },
  {
    id: "N550-SEG-003",
    label: "Ames — Bertamiráns",
    path: [
      { lat: 42.76096, lng: -8.61551 },
      { lat: 42.75918, lng: -8.61704 },
      { lat: 42.76027, lng: -8.61952 },
      { lat: 42.75891, lng: -8.62015 },
      { lat: 42.75661, lng: -8.61965 },
      { lat: 42.75443, lng: -8.61979 },
      { lat: 42.7521, lng: -8.62217 },
      { lat: 42.75069, lng: -8.62078 },
      { lat: 42.75009, lng: -8.62277 },
      { lat: 42.74896, lng: -8.62552 },
      { lat: 42.74627, lng: -8.6265 },
      { lat: 42.74525, lng: -8.6291 },
      { lat: 42.7458, lng: -8.63161 },
      { lat: 42.74734, lng: -8.63467 },
      { lat: 42.74433, lng: -8.63207 },
      { lat: 42.7422, lng: -8.62913 },
      { lat: 42.74284, lng: -8.62684 },
      { lat: 42.74314, lng: -8.6251 },
      { lat: 42.74451, lng: -8.62332 },
      { lat: 42.74562, lng: -8.62194 },
      { lat: 42.74568, lng: -8.62095 },
      { lat: 42.744, lng: -8.6226 },
      { lat: 42.74217, lng: -8.62471 },
      { lat: 42.74183, lng: -8.62579 },
      { lat: 42.74047, lng: -8.62607 },
      { lat: 42.73872, lng: -8.62638 },
      { lat: 42.73745, lng: -8.62753 },
      { lat: 42.73907, lng: -8.63007 },
      { lat: 42.74013, lng: -8.63187 },
      { lat: 42.73916, lng: -8.63296 },
      { lat: 42.73791, lng: -8.63694 },
      { lat: 42.7367, lng: -8.64127 },
      { lat: 42.73541, lng: -8.64616 },
      { lat: 42.73528, lng: -8.64658 },
      { lat: 42.73455, lng: -8.6456 },
      { lat: 42.73249, lng: -8.64538 },
      { lat: 42.73166, lng: -8.64548 },
      { lat: 42.7307, lng: -8.64862 },
      { lat: 42.7292, lng: -8.65262 },
      { lat: 42.72981, lng: -8.65478 }
    ],
  },
  {
    id: "N550-SEG-004",
    label: "A Escravitude",
    path: [
      { lat: 42.72981, lng: -8.65478 },
      { lat: 42.73163, lng: -8.6567 },
      { lat: 42.7317, lng: -8.65843 },
      { lat: 42.73181, lng: -8.65948 },
      { lat: 42.73222, lng: -8.65916 },
      { lat: 42.72925, lng: -8.65739 },
      { lat: 42.72607, lng: -8.65606 },
      { lat: 42.7255, lng: -8.65518 },
      { lat: 42.72551, lng: -8.65175 },
      { lat: 42.72478, lng: -8.65089 },
      { lat: 42.71935, lng: -8.65107 },
      { lat: 42.71653, lng: -8.65149 },
      { lat: 42.71622, lng: -8.6519 },
      { lat: 42.71607, lng: -8.65198 },
      { lat: 42.71561, lng: -8.65165 },
      { lat: 42.71251, lng: -8.65109 },
      { lat: 42.70987, lng: -8.65177 },
      { lat: 42.70989, lng: -8.65204 },
      { lat: 42.70802, lng: -8.65031 },
      { lat: 42.70568, lng: -8.64997 },
      { lat: 42.70554, lng: -8.65008 },
      { lat: 42.7054, lng: -8.64995 },
      { lat: 42.70419, lng: -8.64963 },
      { lat: 42.70008, lng: -8.64892 },
      { lat: 42.69654, lng: -8.64834 },
      { lat: 42.69202, lng: -8.64874 },
      { lat: 42.68913, lng: -8.64921 },
      { lat: 42.68708, lng: -8.64892 },
      { lat: 42.68528, lng: -8.64695 },
      { lat: 42.68349, lng: -8.6445 },
      { lat: 42.68254, lng: -8.6433 },
      { lat: 42.68072, lng: -8.6424 },
      { lat: 42.67817, lng: -8.64073 },
      { lat: 42.67506, lng: -8.63861 },
      { lat: 42.67321, lng: -8.63753 },
      { lat: 42.67015, lng: -8.6364 },
      { lat: 42.66776, lng: -8.63562 },
      { lat: 42.66674, lng: -8.63536 },
      { lat: 42.66526, lng: -8.63601 },
      { lat: 42.66329, lng: -8.63704 }
    ],
  },
  {
    id: "N550-SEG-005",
    label: "Padrón Norte",
    path: [
      { lat: 42.66329, lng: -8.63704 },
      { lat: 42.65959, lng: -8.63765 },
      { lat: 42.65693, lng: -8.63879 },
      { lat: 42.65601, lng: -8.63997 },
      { lat: 42.654, lng: -8.64198 },
      { lat: 42.65081, lng: -8.64448 },
      { lat: 42.64796, lng: -8.64594 },
      { lat: 42.64385, lng: -8.64817 },
      { lat: 42.64123, lng: -8.64993 },
      { lat: 42.63863, lng: -8.64917 },
      { lat: 42.63695, lng: -8.64846 },
      { lat: 42.63281, lng: -8.64876 },
      { lat: 42.63016, lng: -8.64895 },
      { lat: 42.62776, lng: -8.64888 },
      { lat: 42.62516, lng: -8.64872 },
      { lat: 42.62253, lng: -8.64744 },
      { lat: 42.62324, lng: -8.64699 },
      { lat: 42.62497, lng: -8.646 },
      { lat: 42.62531, lng: -8.6446 },
      { lat: 42.62638, lng: -8.64473 },
      { lat: 42.62816, lng: -8.64528 },
      { lat: 42.63024, lng: -8.64506 },
      { lat: 42.63136, lng: -8.64456 },
      { lat: 42.63222, lng: -8.64493 },
      { lat: 42.63404, lng: -8.64499 },
      { lat: 42.6364, lng: -8.64482 },
      { lat: 42.63745, lng: -8.6446 },
      { lat: 42.6389, lng: -8.64462 },
      { lat: 42.64016, lng: -8.64353 },
      { lat: 42.64201, lng: -8.643 },
      { lat: 42.64338, lng: -8.64336 },
      { lat: 42.64506, lng: -8.64339 },
      { lat: 42.64635, lng: -8.64356 },
      { lat: 42.64761, lng: -8.64444 },
      { lat: 42.64924, lng: -8.64502 },
      { lat: 42.65081, lng: -8.64448 },
      { lat: 42.65469, lng: -8.64138 },
      { lat: 42.6564, lng: -8.63945 },
      { lat: 42.65745, lng: -8.63834 },
      { lat: 42.66035, lng: -8.63753 }
    ],
  },
  {
    id: "N550-SEG-006",
    label: "Padrón — A Pobra",
    path: [
      { lat: 42.66035, lng: -8.63753 },
      { lat: 42.66388, lng: -8.63681 },
      { lat: 42.66525, lng: -8.6359 },
      { lat: 42.66537, lng: -8.63576 },
      { lat: 42.6655, lng: -8.63591 },
      { lat: 42.66542, lng: -8.63609 },
      { lat: 42.6646, lng: -8.6364 },
      { lat: 42.66144, lng: -8.63736 },
      { lat: 42.65822, lng: -8.638 },
      { lat: 42.65654, lng: -8.63926 },
      { lat: 42.65518, lng: -8.64093 },
      { lat: 42.65239, lng: -8.64327 },
      { lat: 42.64947, lng: -8.64526 },
      { lat: 42.64514, lng: -8.64749 },
      { lat: 42.64157, lng: -8.64978 },
      { lat: 42.63903, lng: -8.64946 },
      { lat: 42.63719, lng: -8.6485 },
      { lat: 42.6336, lng: -8.64868 },
      { lat: 42.63044, lng: -8.64895 },
      { lat: 42.62776, lng: -8.64888 },
      { lat: 42.62453, lng: -8.64857 },
      { lat: 42.62176, lng: -8.64692 },
      { lat: 42.61971, lng: -8.64644 },
      { lat: 42.61691, lng: -8.6479 },
      { lat: 42.61399, lng: -8.64805 },
      { lat: 42.61141, lng: -8.64668 },
      { lat: 42.6104, lng: -8.64512 },
      { lat: 42.60802, lng: -8.64529 },
      { lat: 42.60439, lng: -8.64222 },
      { lat: 42.60206, lng: -8.6426 },
      { lat: 42.60165, lng: -8.64153 },
      { lat: 42.60109, lng: -8.64049 },
      { lat: 42.59907, lng: -8.64132 },
      { lat: 42.59783, lng: -8.64124 },
      { lat: 42.59731, lng: -8.64088 },
      { lat: 42.59712, lng: -8.64042 },
      { lat: 42.59688, lng: -8.63997 },
      { lat: 42.59543, lng: -8.63954 },
      { lat: 42.59456, lng: -8.63972 },
      { lat: 42.59275, lng: -8.64062 }
    ],
  },
  {
    id: "N550-SEG-007",
    label: "Pontecesures",
    path: [
      { lat: 42.59275, lng: -8.64062 },
      { lat: 42.59152, lng: -8.64098 },
      { lat: 42.59075, lng: -8.64099 },
      { lat: 42.59003, lng: -8.64102 },
      { lat: 42.58945, lng: -8.64278 },
      { lat: 42.58939, lng: -8.64294 },
      { lat: 42.58924, lng: -8.64295 },
      { lat: 42.58694, lng: -8.64275 },
      { lat: 42.58523, lng: -8.64247 },
      { lat: 42.58395, lng: -8.6425 },
      { lat: 42.58027, lng: -8.64228 },
      { lat: 42.57661, lng: -8.64199 },
      { lat: 42.57215, lng: -8.64169 },
      { lat: 42.56922, lng: -8.64147 },
      { lat: 42.56716, lng: -8.64129 },
      { lat: 42.56612, lng: -8.64137 },
      { lat: 42.56599, lng: -8.64128 },
      { lat: 42.56435, lng: -8.641 },
      { lat: 42.5636, lng: -8.64058 },
      { lat: 42.56216, lng: -8.63954 },
      { lat: 42.55992, lng: -8.63793 },
      { lat: 42.55917, lng: -8.63754 },
      { lat: 42.55629, lng: -8.63761 },
      { lat: 42.5529, lng: -8.63802 },
      { lat: 42.55102, lng: -8.63962 },
      { lat: 42.5507, lng: -8.64469 },
      { lat: 42.54808, lng: -8.64528 },
      { lat: 42.54227, lng: -8.6464 },
      { lat: 42.54061, lng: -8.64506 },
      { lat: 42.5406, lng: -8.64245 },
      { lat: 42.53832, lng: -8.64042 },
      { lat: 42.53649, lng: -8.6388 },
      { lat: 42.53549, lng: -8.63761 },
      { lat: 42.53192, lng: -8.63815 },
      { lat: 42.52852, lng: -8.63865 },
      { lat: 42.52622, lng: -8.63893 },
      { lat: 42.52397, lng: -8.63832 },
      { lat: 42.52158, lng: -8.63775 },
      { lat: 42.5199, lng: -8.6379 },
      { lat: 42.51886, lng: -8.63857 }
    ],
  },
  {
    id: "N550-SEG-008",
    label: "Caldas de Reis",
    path: [
      { lat: 42.51886, lng: -8.63857 },
      { lat: 42.51607, lng: -8.64178 },
      { lat: 42.51406, lng: -8.6428 },
      { lat: 42.51131, lng: -8.64244 },
      { lat: 42.5093, lng: -8.64395 },
      { lat: 42.5063, lng: -8.64369 },
      { lat: 42.50351, lng: -8.64225 },
      { lat: 42.50154, lng: -8.64185 },
      { lat: 42.49878, lng: -8.64119 },
      { lat: 42.49668, lng: -8.63922 },
      { lat: 42.49466, lng: -8.64078 },
      { lat: 42.48953, lng: -8.64064 },
      { lat: 42.48665, lng: -8.64313 },
      { lat: 42.48423, lng: -8.64329 },
      { lat: 42.48184, lng: -8.64168 },
      { lat: 42.48083, lng: -8.64219 },
      { lat: 42.48155, lng: -8.64216 },
      { lat: 42.48185, lng: -8.64251 },
      { lat: 42.4814, lng: -8.64284 },
      { lat: 42.48068, lng: -8.64332 },
      { lat: 42.4794, lng: -8.64324 },
      { lat: 42.47789, lng: -8.64369 },
      { lat: 42.47736, lng: -8.64461 },
      { lat: 42.47679, lng: -8.64483 },
      { lat: 42.47538, lng: -8.64552 },
      { lat: 42.47434, lng: -8.64441 },
      { lat: 42.47346, lng: -8.64079 },
      { lat: 42.47275, lng: -8.63844 },
      { lat: 42.47088, lng: -8.63898 },
      { lat: 42.46898, lng: -8.64266 },
      { lat: 42.46642, lng: -8.64268 },
      { lat: 42.46283, lng: -8.64216 },
      { lat: 42.46, lng: -8.64088 },
      { lat: 42.45657, lng: -8.63985 },
      { lat: 42.45323, lng: -8.63891 },
      { lat: 42.45099, lng: -8.63785 },
      { lat: 42.45089, lng: -8.63768 },
      { lat: 42.4507, lng: -8.63687 },
      { lat: 42.4494, lng: -8.63632 },
      { lat: 42.44696, lng: -8.63664 }
    ],
  },
  {
    id: "N550-SEG-009",
    label: "Portas — Barro",
    path: [
      { lat: 42.44696, lng: -8.63664 },
      { lat: 42.44362, lng: -8.63633 },
      { lat: 42.43908, lng: -8.63979 },
      { lat: 42.43712, lng: -8.64078 },
      { lat: 42.43715, lng: -8.64629 },
      { lat: 42.43734, lng: -8.64858 },
      { lat: 42.4371, lng: -8.64862 },
      { lat: 42.43598, lng: -8.64823 },
      { lat: 42.43452, lng: -8.65018 },
      { lat: 42.43438, lng: -8.65013 },
      { lat: 42.43331, lng: -8.64973 },
      { lat: 42.4329, lng: -8.65124 },
      { lat: 42.43315, lng: -8.65198 },
      { lat: 42.43162, lng: -8.65325 },
      { lat: 42.42907, lng: -8.65371 },
      { lat: 42.42844, lng: -8.65188 },
      { lat: 42.42694, lng: -8.65252 },
      { lat: 42.42671, lng: -8.65155 },
      { lat: 42.42616, lng: -8.65044 },
      { lat: 42.42605, lng: -8.64947 },
      { lat: 42.42542, lng: -8.64734 },
      { lat: 42.42483, lng: -8.64721 },
      { lat: 42.422, lng: -8.64692 },
      { lat: 42.41837, lng: -8.64645 },
      { lat: 42.41791, lng: -8.64436 },
      { lat: 42.41801, lng: -8.64394 },
      { lat: 42.41738, lng: -8.64364 },
      { lat: 42.41729, lng: -8.64348 },
      { lat: 42.41677, lng: -8.64179 },
      { lat: 42.41694, lng: -8.64074 },
      { lat: 42.4171, lng: -8.64005 },
      { lat: 42.41752, lng: -8.63847 },
      { lat: 42.41614, lng: -8.63843 },
      { lat: 42.41346, lng: -8.63858 },
      { lat: 42.41263, lng: -8.63897 },
      { lat: 42.40939, lng: -8.63949 },
      { lat: 42.4039, lng: -8.63931 },
      { lat: 42.39733, lng: -8.63584 },
      { lat: 42.39439, lng: -8.63523 },
      { lat: 42.38581, lng: -8.63521 }
    ],
  },
  {
    id: "N550-SEG-010",
    label: "Pontevedra Norte",
    path: [
      { lat: 42.38581, lng: -8.63521 },
      { lat: 42.38145, lng: -8.63471 },
      { lat: 42.37918, lng: -8.6346 },
      { lat: 42.37551, lng: -8.63505 },
      { lat: 42.37377, lng: -8.63574 },
      { lat: 42.37173, lng: -8.63546 },
      { lat: 42.3689, lng: -8.63387 },
      { lat: 42.36537, lng: -8.63308 },
      { lat: 42.36345, lng: -8.63191 },
      { lat: 42.36055, lng: -8.63014 },
      { lat: 42.35749, lng: -8.62829 },
      { lat: 42.35554, lng: -8.62716 },
      { lat: 42.35363, lng: -8.62661 },
      { lat: 42.35248, lng: -8.62556 },
      { lat: 42.35123, lng: -8.62416 },
      { lat: 42.35053, lng: -8.62286 },
      { lat: 42.35, lng: -8.62155 },
      { lat: 42.34936, lng: -8.62211 },
      { lat: 42.34922, lng: -8.62215 },
      { lat: 42.34852, lng: -8.6223 },
      { lat: 42.34852, lng: -8.62309 },
      { lat: 42.35022, lng: -8.62335 },
      { lat: 42.35052, lng: -8.6226 },
      { lat: 42.35043, lng: -8.62105 },
      { lat: 42.3494, lng: -8.61636 },
      { lat: 42.34789, lng: -8.61294 },
      { lat: 42.3449, lng: -8.61168 },
      { lat: 42.34331, lng: -8.61185 },
      { lat: 42.34228, lng: -8.61051 },
      { lat: 42.33624, lng: -8.60734 },
      { lat: 42.33292, lng: -8.60683 },
      { lat: 42.33016, lng: -8.60682 },
      { lat: 42.3283, lng: -8.60585 },
      { lat: 42.32649, lng: -8.60666 },
      { lat: 42.32466, lng: -8.60904 },
      { lat: 42.32425, lng: -8.61048 },
      { lat: 42.32435, lng: -8.61201 },
      { lat: 42.32293, lng: -8.61335 },
      { lat: 42.32214, lng: -8.61498 },
      { lat: 42.32118, lng: -8.61534 }
    ],
  },
  {
    id: "N550-SEG-011",
    label: "Pontevedra Centro",
    path: [
      { lat: 42.32118, lng: -8.61534 },
      { lat: 42.31998, lng: -8.61461 },
      { lat: 42.31907, lng: -8.6154 },
      { lat: 42.31766, lng: -8.61659 },
      { lat: 42.31593, lng: -8.61728 },
      { lat: 42.31274, lng: -8.61639 },
      { lat: 42.31104, lng: -8.61444 },
      { lat: 42.3104, lng: -8.61236 },
      { lat: 42.31166, lng: -8.61194 },
      { lat: 42.31203, lng: -8.61085 },
      { lat: 42.31257, lng: -8.61051 },
      { lat: 42.31179, lng: -8.61172 },
      { lat: 42.31051, lng: -8.61234 },
      { lat: 42.31018, lng: -8.61246 },
      { lat: 42.30896, lng: -8.61002 },
      { lat: 42.30883, lng: -8.60836 },
      { lat: 42.30763, lng: -8.60678 },
      { lat: 42.30559, lng: -8.60331 },
      { lat: 42.3038, lng: -8.6031 },
      { lat: 42.29966, lng: -8.60266 },
      { lat: 42.29886, lng: -8.60541 },
      { lat: 42.2977, lng: -8.60645 },
      { lat: 42.29554, lng: -8.6052 },
      { lat: 42.29352, lng: -8.60619 },
      { lat: 42.2903, lng: -8.60801 },
      { lat: 42.28669, lng: -8.60997 },
      { lat: 42.28273, lng: -8.61136 },
      { lat: 42.28214, lng: -8.6127 },
      { lat: 42.28338, lng: -8.61359 },
      { lat: 42.28337, lng: -8.61628 },
      { lat: 42.28312, lng: -8.61881 },
      { lat: 42.28305, lng: -8.61904 },
      { lat: 42.2824, lng: -8.62401 },
      { lat: 42.28265, lng: -8.62695 },
      { lat: 42.2839, lng: -8.62949 },
      { lat: 42.28451, lng: -8.63292 },
      { lat: 42.28488, lng: -8.63558 },
      { lat: 42.2865, lng: -8.6376 },
      { lat: 42.28768, lng: -8.64001 },
      { lat: 42.28862, lng: -8.64445 }
    ],
  },
  {
    id: "N550-SEG-012",
    label: "Pontevedra Sur — Arcade",
    path: [
      { lat: 42.28862, lng: -8.64445 },
      { lat: 42.28772, lng: -8.64786 },
      { lat: 42.28602, lng: -8.65159 },
      { lat: 42.28467, lng: -8.6538 },
      { lat: 42.28413, lng: -8.65541 },
      { lat: 42.2833, lng: -8.65749 },
      { lat: 42.28287, lng: -8.65971 },
      { lat: 42.28099, lng: -8.66078 },
      { lat: 42.28025, lng: -8.66094 },
      { lat: 42.27951, lng: -8.66162 },
      { lat: 42.27917, lng: -8.66447 },
      { lat: 42.27832, lng: -8.66545 },
      { lat: 42.27505, lng: -8.66672 },
      { lat: 42.27168, lng: -8.66436 },
      { lat: 42.26948, lng: -8.66452 },
      { lat: 42.26819, lng: -8.66577 },
      { lat: 42.26599, lng: -8.66745 },
      { lat: 42.26283, lng: -8.66946 },
      { lat: 42.26235, lng: -8.6702 },
      { lat: 42.2605, lng: -8.67202 },
      { lat: 42.25777, lng: -8.67492 },
      { lat: 42.25645, lng: -8.6777 },
      { lat: 42.25389, lng: -8.68212 },
      { lat: 42.25088, lng: -8.68491 },
      { lat: 42.24929, lng: -8.68674 },
      { lat: 42.24859, lng: -8.69033 },
      { lat: 42.24689, lng: -8.6927 },
      { lat: 42.24602, lng: -8.69369 },
      { lat: 42.24488, lng: -8.69504 },
      { lat: 42.24275, lng: -8.69799 },
      { lat: 42.2424, lng: -8.70081 },
      { lat: 42.24239, lng: -8.70097 },
      { lat: 42.24079, lng: -8.70249 },
      { lat: 42.23912, lng: -8.70397 },
      { lat: 42.23897, lng: -8.70392 },
      { lat: 42.23707, lng: -8.70339 },
      { lat: 42.23635, lng: -8.70419 },
      { lat: 42.23444, lng: -8.70639 },
      { lat: 42.23446, lng: -8.71063 },
      { lat: 42.23358, lng: -8.71389 }
    ],
  },
  {
    id: "N550-SEG-013",
    label: "Redondela",
    path: [
      { lat: 42.23358, lng: -8.71389 },
      { lat: 42.23399, lng: -8.71742 },
      { lat: 42.23568, lng: -8.72283 },
      { lat: 42.23625, lng: -8.72462 },
      { lat: 42.23554, lng: -8.72413 },
      { lat: 42.23476, lng: -8.72542 },
      { lat: 42.2346, lng: -8.72575 },
      { lat: 42.23089, lng: -8.72294 },
      { lat: 42.22939, lng: -8.71993 },
      { lat: 42.22885, lng: -8.71933 },
      { lat: 42.22618, lng: -8.71483 },
      { lat: 42.22256, lng: -8.7086 },
      { lat: 42.21879, lng: -8.70414 },
      { lat: 42.21634, lng: -8.70135 },
      { lat: 42.21409, lng: -8.69897 },
      { lat: 42.21407, lng: -8.69837 },
      { lat: 42.2141, lng: -8.69692 },
      { lat: 42.21161, lng: -8.69682 },
      { lat: 42.20967, lng: -8.69566 },
      { lat: 42.20864, lng: -8.69575 },
      { lat: 42.20732, lng: -8.69617 },
      { lat: 42.20604, lng: -8.69552 },
      { lat: 42.20553, lng: -8.69293 },
      { lat: 42.20454, lng: -8.69374 },
      { lat: 42.20359, lng: -8.69369 },
      { lat: 42.2026, lng: -8.69392 },
      { lat: 42.20188, lng: -8.69318 },
      { lat: 42.20123, lng: -8.69235 },
      { lat: 42.19939, lng: -8.69287 },
      { lat: 42.1993, lng: -8.69524 },
      { lat: 42.19787, lng: -8.69601 },
      { lat: 42.19682, lng: -8.69642 },
      { lat: 42.19601, lng: -8.69621 },
      { lat: 42.19438, lng: -8.69705 },
      { lat: 42.19205, lng: -8.69691 },
      { lat: 42.19045, lng: -8.69607 },
      { lat: 42.18852, lng: -8.69459 },
      { lat: 42.18665, lng: -8.69488 },
      { lat: 42.18493, lng: -8.69589 },
      { lat: 42.18329, lng: -8.6969 }
    ],
  },
  {
    id: "N550-SEG-014",
    label: "Vigo",
    path: [
      { lat: 42.18329, lng: -8.6969 },
      { lat: 42.18164, lng: -8.69679 },
      { lat: 42.17981, lng: -8.69685 },
      { lat: 42.17785, lng: -8.69702 },
      { lat: 42.17683, lng: -8.69602 },
      { lat: 42.17399, lng: -8.69556 },
      { lat: 42.17184, lng: -8.69466 },
      { lat: 42.17018, lng: -8.69334 },
      { lat: 42.16779, lng: -8.69248 },
      { lat: 42.16482, lng: -8.68793 },
      { lat: 42.16421, lng: -8.68384 },
      { lat: 42.16389, lng: -8.67917 },
      { lat: 42.16381, lng: -8.67811 },
      { lat: 42.16228, lng: -8.67771 },
      { lat: 42.16023, lng: -8.67617 },
      { lat: 42.15741, lng: -8.67422 },
      { lat: 42.15521, lng: -8.67333 },
      { lat: 42.15604, lng: -8.67079 },
      { lat: 42.15818, lng: -8.67018 },
      { lat: 42.15749, lng: -8.66805 },
      { lat: 42.15664, lng: -8.66455 },
      { lat: 42.15418, lng: -8.66112 },
      { lat: 42.15139, lng: -8.66129 },
      { lat: 42.14983, lng: -8.66274 },
      { lat: 42.14895, lng: -8.66395 },
      { lat: 42.14864, lng: -8.66387 },
      { lat: 42.14754, lng: -8.66523 },
      { lat: 42.14688, lng: -8.66682 },
      { lat: 42.14575, lng: -8.66741 },
      { lat: 42.14484, lng: -8.66656 },
      { lat: 42.14374, lng: -8.6647 },
      { lat: 42.14034, lng: -8.66316 },
      { lat: 42.13822, lng: -8.66144 },
      { lat: 42.1361, lng: -8.65907 },
      { lat: 42.13479, lng: -8.65944 },
      { lat: 42.13291, lng: -8.65726 },
      { lat: 42.13128, lng: -8.65783 },
      { lat: 42.13017, lng: -8.6578 },
      { lat: 42.12829, lng: -8.6571 },
      { lat: 42.12692, lng: -8.65656 }
    ],
  },
  {
    id: "N550-SEG-015",
    label: "Porriño — Tui",
    path: [
      { lat: 42.12692, lng: -8.65656 },
      { lat: 42.12607, lng: -8.65385 },
      { lat: 42.12284, lng: -8.65323 },
      { lat: 42.1208, lng: -8.65299 },
      { lat: 42.11944, lng: -8.65304 },
      { lat: 42.11678, lng: -8.65123 },
      { lat: 42.11359, lng: -8.65005 },
      { lat: 42.11091, lng: -8.64903 },
      { lat: 42.10849, lng: -8.64786 },
      { lat: 42.10667, lng: -8.64921 },
      { lat: 42.10493, lng: -8.64996 },
      { lat: 42.10371, lng: -8.64949 },
      { lat: 42.10237, lng: -8.64903 },
      { lat: 42.10102, lng: -8.6488 },
      { lat: 42.09913, lng: -8.64836 },
      { lat: 42.09722, lng: -8.64795 },
      { lat: 42.09487, lng: -8.64627 },
      { lat: 42.09342, lng: -8.64669 },
      { lat: 42.09209, lng: -8.64678 },
      { lat: 42.08966, lng: -8.64533 },
      { lat: 42.08827, lng: -8.64444 },
      { lat: 42.08686, lng: -8.64321 },
      { lat: 42.08514, lng: -8.64199 },
      { lat: 42.08401, lng: -8.64177 },
      { lat: 42.08187, lng: -8.64054 },
      { lat: 42.08071, lng: -8.63914 },
      { lat: 42.07926, lng: -8.63887 },
      { lat: 42.07726, lng: -8.6385 },
      { lat: 42.07563, lng: -8.6397 },
      { lat: 42.07331, lng: -8.63918 },
      { lat: 42.0711, lng: -8.6387 },
      { lat: 42.06945, lng: -8.63903 },
      { lat: 42.06712, lng: -8.63852 },
      { lat: 42.065, lng: -8.63777 },
      { lat: 42.06344, lng: -8.64006 },
      { lat: 42.06027, lng: -8.64189 },
      { lat: 42.0575, lng: -8.64204 },
      { lat: 42.0539, lng: -8.6439 },
      { lat: 42.05158, lng: -8.64662 },
      { lat: 42.05196, lng: -8.64802 }
    ],
  },
];
